module.exports = __webpack_public_path__ + "components/country-flag/static/un-6ce254543054b7f911779b4aa8964be6.svg";